module.exports = __webpack_public_path__ + "static/ring_of_animal_influence-73cd6b6bdd2fe63c2e911ea06e6999ed.jpeg";